// MessageCategoryTabAllInOne.js
'use strict';
'use client';
import { connect } from 'react-redux';

import MessageCategoryTabAllInOne from '../component/MessageCategoryTabAllInOne.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getCategoryFeedsHasMessages from '../selector/getCategoryFeedsHasMessages.js';

import { CATEGORY_FEED_ALL } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { match, categoryId: propsCategoryId }) => {
  const categoryId = propsCategoryId || match?.params?.categoryId;
  const categoryFeeds = getRemoteConfigData(
    state,
    CATEGORY_FEED_ALL,
    undefined,
    {
      CATEGORY: categoryId,
    }
  );

  const categoryFeedsHasMessages = getCategoryFeedsHasMessages(
    state,
    categoryFeeds
  );

  return {
    categoryId,
    categoryTemplates: getRemoteConfigData(state, CATEGORY_FEED_ALL),
    categoryFeeds,
    categoryFeedsHasMessages,
    // undefined = not yet fetched (FeedMessages pending), false = fetched and empty, true = has items.
    // Only show empty state when every feed has been fetched and returned 0 items.
    isFetchedAndEmpty: Object.values(categoryFeedsHasMessages).every(
      hasMessages => hasMessages !== undefined && hasMessages === false
    ),
  };
};

export default connect(mapStateToProps, null)(MessageCategoryTabAllInOne);
